import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { B2BAuthContext } from '../../../Context/AuthContex/B2BAuthContext';
import Toaster from '../../../Components/Toaster/Toaster';
import PostDataApis from '../../../Components/Common/FetchData/PostDataApis';
import { B2B_USER_SUCCESS } from '../../../Helpers/Constant';
import Layout from '../../../Components/Layout/Layout';
import InputField from '../../../Components/Common/InputField';
import SelectField from '../../../Components/Common/SelectField';
import CommonImageUpload from '../../../Components/Common/CommonImageUpload';
import SelectTextArea from '../../../Components/Common/SelectTextArea';
import { CustomMultiSelect } from '../../../Components/Common/CustomMultipleSelect';
import Loader from '../../../Components/Spinner/Loader';
import PrevRegistrationManagement from '../../../Components/Common/CheckPreviousRegistration/PrevRegistrationManagement';
import CheckMember from '../../../Components/Common/CheckPreviousRegistration/CheckMember';
import OnlyRegistrationOTP from '../../../Components/Common/CheckPreviousRegistration/OnlyRegistrationOTP';
import { useCheckPreviousRegistration } from '../../../Components/Common/apiEndpoints/commApiEndpoints';
import ShowingPasswordValidationText from '../../../Components/Common/ShowingPasswordValidationText';

interface inputForm {
  b2b_organization: string;
  b2b_company_brief: string;
  b2b_first_name: string;
  b2b_last_name: string;
  b2b_email: string;
  b2b_phone: string;
  b2b_password: string;
  b2b_photo: string;
  b2b_type: string;
  b2b_designation: string;
  b2b_website: string;
  b2b_address: string;
  b2b_country: string;
  b2b_telephone_number: string;
  b2b_terms_and_conditions: any;
  b2b_business_type: string;
  b2b_city: string;
  b2b_confirm_password: string;
  b2b_id_number: string;
  b2b_id_type: string;
  b2b_intention: string;
  b2b_locations: number[];
  continent_id: string;
}

const B2BRegistration = () => {
  const [back, setBack] = useState(false);
  const [registrationData, setRegistrationData] = useState<any>({});
  const [searchParams] = useSearchParams();
  const b2b_type = searchParams.get('type');
  const { dispatch: authDispatch, setIsLoading } = B2BAuthContext();
  const Toast = Toaster();
  const navigate = useNavigate();
  const {
    mutate,
    isSuccess: otpSuccess,
    isPending,
  } = useCheckPreviousRegistration();

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    setValue,
    resetField,
    watch,
    control,
    formState: { errors },
  } = useForm<any>();
  const id_type = watch('b2b_id_type');
  const [passwordType, setPasswordType] = useState<string>('password');
  const { postData, loading, token, response } = PostDataApis(
    '/api/auth/b2b/registration',
  );
  const [isRegistered, setIsRegistered] = useState<'yes' | 'no' | null>(null);

  useEffect(() => {
    if (response && token) {
      authDispatch?.({
        type: B2B_USER_SUCCESS,
        payload: { ...response, token },
      });

      localStorage.setItem('toab_fair', token);
      setIsLoading?.(false);
      navigate('/b2b/profile');
    }
  }, [response, token]);

  const onSubmit: SubmitHandler<inputForm> = async (value: inputForm) => {
    const { b2b_confirm_password, b2b_locations, continent_id, ...data } =
      value || {};

    const b2b_location = b2b_locations?.map((item: number) => ({
      b2b_location_id: item,
      b2b_location_type: 'country',
    }));

    const allLocations = [
      { b2b_location_id: continent_id, b2b_location_type: 'continent' },
      ...b2b_location,
    ];
    if (data?.b2b_password !== b2b_confirm_password) {
      Toast.fire({
        icon: 'error',
        title: `Password does not match`,
      });
      setIsLoading?.(false);
      return;
    }
    if (data?.b2b_password?.length < 8) {
      Toast.fire({
        icon: 'error',
        title: `Password must be at least 8 characters`,
      });
      setIsLoading?.(false);
      return;
    }
    if (data?.b2b_password?.length > 16) {
      Toast.fire({
        icon: 'error',
        title: `Maximum password length is 16 characters`,
      });

      return;
    }
    mutate({
      email: data?.b2b_email,
      type: 'register_b2b',
      phone: data?.b2b_phone,
    });
    setRegistrationData({ ...data, allLocations });
    setBack(false);
  };

  const handleRegistration = async (value: boolean) => {
    setIsLoading?.(true);
    if (value) {
      const fromData = new FormData();
      const { allLocations, ...restData } = registrationData || {};
      fromData.append('b2b_locations', JSON.stringify(allLocations));
      Object.keys(restData).forEach((item) => {
        if (item === 'b2b_photo') {
          fromData.append(item, restData[item][0]);
        } else {
          fromData.append(item, restData[item]);
        }
      });
      await postData(fromData);
    }
  };

  useEffect(() => {
    if (b2b_type) {
      setValue('b2b_type', b2b_type);
    }
  }, [b2b_type]);
  return (
    <Layout>
      {Object?.keys(registrationData)?.length && otpSuccess && !back ? (
        <OnlyRegistrationOTP
          email={registrationData?.b2b_email}
          handleRegistration={handleRegistration}
          type='register_b2b'
          setBack={setBack}
        />
      ) : (
        <div className='login-wrapper mt-4'>
          <div className='login-div'>
            <div className='visitor-registration-page'>
              <div className='text-center'>
                <p className='fw-bold fs-3 py-1'>
                  {b2b_type === 'Both' ? 'Buyer/Seller' : b2b_type} B2B Meeting
                  Registration
                </p>
              </div>

              <div className='login-form'>
                <div>
                  <div className='d-flex gap-2'>
                    <span
                      style={{
                        color: 'red',
                        fontWeight: 'bold',
                      }}
                    >
                      Note:
                    </span>{' '}
                    <p style={{ fontWeight: 'bold' }}>
                      We warmly invite you to join our exclusive event, 13th ATF
                      2025, from 26 Nov - 28 NOV 2025 <br />
                    </p>
                  </div>
                  <hr className='hr' />
                </div>
                {/* <CheckMember handleCheck={(value) => setIsRegistered(value)} /> */}

                {isRegistered === 'yes' ? (
                  // <PrevRegistrationManagement />
                  <></>
                ) : (
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='row g-3 mx'>
                      <div className='col-12'>
                        <p className='fw-bold fs-5 text-center text-decoration-underline'>
                          Company Information
                        </p>
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <InputField
                          label='First Name'
                          isRequired
                          register={register('b2b_first_name')}
                          placeholder='Enter first name'
                          type='text'
                        />
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <InputField
                          label='Last Name'
                          isRequired
                          register={register('b2b_last_name')}
                          placeholder='Enter last name'
                          type='text'
                        />
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <InputField
                          label='Designation'
                          isRequired
                          register={register('b2b_designation')}
                          placeholder='Designation'
                          type='text'
                        />
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <InputField
                          label='Mobile No'
                          isRequired
                          register={register('b2b_phone')}
                          placeholder='Mobile No'
                          type='number'
                        />
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <InputField
                          label='Email Address'
                          isRequired
                          register={register('b2b_email')}
                          placeholder='Enter Official Email Address'
                          type='email'
                        />
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <SelectField
                          fieldName='b2b_id_type'
                          isRequired
                          register={register}
                          label='Passport/NID'
                          options={[
                            { label: 'Passport', value: 'Passport' },
                            { label: 'NID', value: 'NID' },
                          ]}
                          placeholder='Please Select'
                        />
                      </div>

                      {id_type && (
                        <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                          <InputField
                            label={
                              id_type === 'Passport'
                                ? 'Passport No.'
                                : 'NID No.'
                            }
                            register={register('b2b_id_number')}
                            type='text'
                            isRequired
                            placeholder={
                              id_type === 'Passport'
                                ? 'Passport No.'
                                : 'NID No.'
                            }
                          />
                        </div>
                      )}

                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <InputField
                          label='Company Name'
                          isRequired
                          register={register('b2b_organization')}
                          placeholder='Company Name'
                          type='text'
                        />
                      </div>

                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <InputField
                          label='Address'
                          isRequired
                          register={register('b2b_address')}
                          placeholder='Address'
                          type='text'
                        />
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <InputField
                          label='Website'
                          register={register('b2b_website')}
                          placeholder='Website'
                          type='text'
                        />
                      </div>

                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <InputField
                          label='City'
                          isRequired
                          register={register('b2b_city')}
                          placeholder='City'
                          type='text'
                        />
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <InputField
                          label='Country'
                          isRequired
                          register={register('b2b_country')}
                          placeholder='Country'
                          type='text'
                        />
                      </div>

                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <InputField
                          label='Telephone No'
                          register={register('b2b_telephone_number')}
                          placeholder='Telephone No'
                          type='number'
                        />
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <SelectField
                          fieldName='b2b_business_type'
                          isRequired
                          register={register}
                          label='Business Type'
                          options={[
                            { label: 'Tour Operator', value: 'Tour Operator' },
                            {
                              label: 'Destination Company',
                              value: 'Destination Company',
                            },
                            { label: 'Hotel', value: 'Hotel' },
                            { label: 'Airline', value: 'Airline' },
                          ]}
                          placeholder='Please Select'
                        />
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                        <SelectTextArea
                          label='Brief About the Company'
                          register={register('b2b_company_brief')}
                          placeholder='Brief About the Company'
                          type='textarea'
                          isRequired
                          rows={2}
                        />
                      </div>

                      <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2'>
                        <div className='row'>
                          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 mt-2'>
                            <CommonImageUpload
                              register={register}
                              setError={setError}
                              clearErrors={clearErrors}
                              setValue={setValue}
                              resetField={resetField}
                              errors={errors}
                              required
                              label='Upload a Passport Size Photo'
                              fileName='b2b_photo'
                            />
                          </div>
                        </div>
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2'>
                        <div className='row'>
                          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 mt-2'>
                            <SelectField
                              fieldName='b2b_type'
                              isRequired
                              register={register}
                              label='Register Account Type'
                              defaultValue={b2b_type}
                              options={[
                                { label: 'Buyer', value: 'Buyer' },
                                { label: 'Seller', value: 'Seller' },
                                { label: 'Both', value: 'Both' },
                              ]}
                              placeholder='Please Select'
                            />
                          </div>
                          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 mt-2'>
                            <SelectField
                              fieldName='continent_id'
                              clearIcon
                              isRequired
                              register={register}
                              label='Select Continent'
                              options={[
                                { value: 3, label: 'Africa' },
                                { value: 6, label: 'Antarctica' },
                                { value: 1, label: 'Asia' },
                                { value: 2, label: 'Europe' },
                                { value: 5, label: 'North America' },
                                { value: 4, label: 'Oceania' },
                                { value: 7, label: 'South America' },
                              ]}
                              placeholder='Please Select'
                            />
                          </div>
                          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 mt-2'>
                            <CustomMultiSelect
                              placeholder='Select Country'
                              isRequired
                              label='Operating Area'
                              name='b2b_locations'
                              setValue={setValue}
                              register={register}
                              watch={watch}
                              errors={errors}
                              control={control}
                            />
                          </div>

                          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 mt-2'>
                            <SelectTextArea
                              label='Write your Intension'
                              isRequired
                              register={register('b2b_intention')}
                              placeholder='Country'
                              type='text'
                              rows={3}
                            />
                          </div>
                        </div>
                      </div>

                      <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                        <InputField
                          isRequired
                          label='Password'
                          register={register('b2b_password')}
                          placeholder='Password'
                          type={passwordType}
                        />
                      </div>

                      <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                        <InputField
                          isRequired
                          label='Confirm Password'
                          register={register('b2b_confirm_password')}
                          placeholder='Confirm Password'
                          type={passwordType}
                        />
                      </div>
                    </div>
                    {((watch('b2b_password') &&
                      watch('b2b_password')?.length < 8) ||
                      watch('b2b_password')?.length > 16) && (
                      <ShowingPasswordValidationText />
                    )}

                    <div className='mt-3'>
                      <div className=' d-flex align-items-center'>
                        <input
                          type='checkbox'
                          onClick={() => {
                            passwordType === 'password'
                              ? setPasswordType('text')
                              : setPasswordType('password');
                          }}
                        />
                        <p className='ps-2'>Show password</p>
                      </div>
                    </div>

                    <div className=''>
                      <div className='d-flex align-items-center'>
                        <input
                          {...register('b2b_terms_and_conditions')}
                          required
                          name='b2b_terms_and_conditions'
                          value={'1'}
                          type='checkbox'
                        />
                        <p className='ps-2'>
                          I accept the Buyer/Seller B2B Meeting Registration
                          Terms & Conditions and Privacy Terms.
                        </p>
                      </div>
                    </div>

                    <div>
                      {isPending ? (
                        <Loader css={'w-100 mt-3 text-white'} />
                      ) : (
                        <Button
                          type='submit'
                          className='w-100 mt-3 submit-button common-btn'
                        >
                          Register
                        </Button>
                      )}
                    </div>

                    <div className='mt-3 text-end'>
                      Already Registered?{' '}
                      <Link
                        to={
                          b2b_type === 'Buyer'
                            ? '/b2b-login?type=Buyer'
                            : b2b_type === 'Both'
                              ? '/b2b-login?type=Both'
                              : '/b2b-login?type=Seller'
                        }
                        style={{ fontWeight: 'bold' }}
                        className='text-decoration-none'
                      >
                        {b2b_type === 'Both' ? 'Buyer/Seller' : b2b_type} B2B
                        Meeting Login
                      </Link>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default B2BRegistration;
